import React, {Component} from 'react';
import {Nav, NavbarBrand, NavbarToggler,} from 'reactstrap';
import {getGlobalState} from "../../constants/GlobalStore";
import {EventClient} from "../../util/eventClient";
import AccountDropdown from "./AccountDropdown";
import HeaderDropdown from "./HeaderDropdown";
import {SMSDropdown} from "./SMSDropdown";
import {TimeClock} from "./TimeClock";

class Header extends Component {

  constructor(props) {
    super(props);
    // console.log(props);
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  exitSimulation() {
    EventClient.emit("TOAST_SUCCESS", "Success. Please Wait...");
    if (document.location.pathname === "/admin/users") {
      document.location.reload();
    } else {
      document.location.assign("/admin/users");
    }
  }

  render() {
    return (<header className="app-header navbar">
      <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
        <span className="navbar-toggler-icon"></span>
      </NavbarToggler>
      <NavbarBrand href="#"></NavbarBrand>
      <NavbarToggler className="d-md-down-none" onClick={this.sidebarToggle}>
        <span className="navbar-toggler-icon"></span>
      </NavbarToggler>
      {/*<Nav className="d-md-down-none" navbar>*/}
      {/*  <NavItem className="px-3">*/}
      {/*    <NavLink href="#">Dashboard</NavLink>*/}
      {/*  </NavItem>*/}
      {/*  <NavItem className="px-3">*/}
      {/*    <NavLink href="#">Users</NavLink>*/}
      {/*  </NavItem>*/}
      {/*  <NavItem className="px-3">*/}
      {/*    <NavLink href="#">Settings</NavLink>*/}
      {/*  </NavItem>*/}
      {/*</Nav>*/}
      <Nav className="ml-auto" navbar>
        {getGlobalState("banner") && (<div style={{marginRight: 10}}>{getGlobalState("banner")}</div>)}
        {getGlobalState("origUser") && (<div style={{marginRight: 10}}>Simulating User
          <span style={{cursor: "pointer"}}
                onClick={() => this.exitSimulation()}
          > (Exit)</span></div>)}
        <div style={{marginRight: 10, cursor: "pointer"}} title={"Open Email"}
             onClick={() => window.open("/myemail")}>
          <i className="icon-envelope-letter"></i>
        </div>
        {/*<HeaderDropdown notif/>*/}
        {/*<HeaderDropdown tasks/>*/}
        {/*<HeaderDropdown mssgs/>*/}
        {/*<NavItem className="d-md-down-none">*/}
        {/*  <NavLink href="#"><i className="icon-location-pin"></i></NavLink>*/}
        {/*</NavItem>*/}
        <TimeClock/>
        <SMSDropdown/>
        <AccountDropdown/>
      </Nav>
      <NavbarToggler className="d-md-down-none" onClick={this.asideToggle}>
        <span className="navbar-toggler-icon"></span>
      </NavbarToggler>
    </header>);
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js